import { baseUrl } from './routes';

export class ConsentFormRoutes {
  static get consentForm(): string {
    return `${baseUrl}/client-consent-form`;
  }
}
